import AdminApi from '../services/api';
import swal from 'sweetalert2';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

/* init */

const AdminApiService = new AdminApi()

export default{

    props: ['show','companyId'],

    data() {
        return {
            title: '',
            isLoading: false,
            hasError: '',
            fromDate: '',
            toDate: '',
            couriersMap: new Map(),
            schedules: []
        };
    },

    watch: {

    },

    beforeMount() {
        this.fromDate = this.$moment(new Date()).format('YYYY-MM-DD')
        this.toDate = this.$moment(new Date()).format('YYYY-MM-DD')
    },

    methods: {
        close() {
            this.$topnavbar.$emit('closePrintSchedule')
        },
        getSchedulesAndGeneratePdf: getSchedulesAndGeneratePdf,
        formatDate: formatDate,
        getDriverStartTime: getDriverStartTime,
        generateCSV: generateCSV,
        generatePDF: generatePDF,
        changedDateFrom: changedDateFrom,
        generateDates: generateDates,
        changedDateTo: changedDateTo,
        compareByTime(a, b) {
            var firstTime = 0.0
            var secondTime = 0.0

            try {
                firstTime = parseFloat(a.startShift.split(":")[0]) + parseFloat(a.startShift.split(":")[1])/100.0;
            }catch (e) { firstTime = 0.0;}
            try {
                secondTime = parseFloat(b.startShift.split(":")[0]) + parseFloat(b.startShift.split(":")[1])/100.0;
            }catch (e) { secondTime = 0.0;}

            let aTime = firstTime;
            let bTime = secondTime;
            if(aTime === bTime){
                return a.firstName.localeCompare(b.firstName)
            }
            if (aTime < bTime)
                return -1;
            if (aTime > bTime)
                return 1;
            return 0;
        },

        compareDriversByTime(a, b) {
            var firstTime = 0.0
            var secondTime = 0.0

            try {
                firstTime = parseFloat(a.choosedTime.HH) + parseFloat(a.choosedTime.mm)/100.0;
            }catch (e) { firstTime = 0.0;}
            try {
                secondTime = parseFloat(b.choosedTime.HH) + parseFloat(b.choosedTime.mm)/100.0;
            }catch (e) { secondTime = 0.0;}

            let aTime = firstTime;
            let bTime = secondTime;
            if(aTime === bTime){
                return a.firstName.localeCompare(b.firstName)
            }
            if (aTime < bTime)
                return -1;
            if (aTime > bTime)
                return 1;
            return 0;
        },
    }
}



function generateDates(from, to){
    let _self = this;
    let HOUR_24 = 1000*60*60*24;
    var dates = [];
    var firstDate = from;
    while (firstDate <= to){
        dates.push(_self.formatDate(firstDate));
        firstDate = firstDate + HOUR_24;
    }
    return dates;
}

function getSchedulesAndGeneratePdf(margin) {
    var _self = this;
    var calendarTimestampFrom = Date.parse(_self.fromDate);
    var calendarTimestampTo = Date.parse(_self.toDate);
    if(isNaN(calendarTimestampFrom)){
        if(_self.hasError == null){
            swal('Greška', 'Izaberite validan datum', 'error');
            _self.hasError = 'notvalid'
        }

        return;
    }
    if(isNaN(calendarTimestampTo)){
        if(_self.hasError == null){
            swal('Greška', 'Izaberite validan datum', 'error');
            _self.hasError = 'notvalid'
        }
        return;
    }
    _self.isLoading = true;
    _self.isDateError = null;
    var dates = this.generateDates(calendarTimestampFrom, calendarTimestampTo)
    var date =  "?fromTimestamp=" + calendarTimestampFrom + "&toTimestamp="+calendarTimestampTo;
    AdminApiService.getSchedules(date)
        .then((response) => {
            _self.schedules = response.data;
            _self.couriersMap = new Map();
            for(var d = 0; d < dates.length; d++){
                _self.couriersMap.set(dates[d], []);
            }
            _self.schedules.forEach(s => {
                let sDate = _self.formatDate(s.timestamp)
                let sCourierName = s.courier.lastName;//capitalizeName(s.courier.firstName);
                // console.log("DATE "+sDate);
                // console.log("GET BY DATE " + _self.couriersMap.get(sDate))
                if(_self.couriersMap.get(sDate) == null){
                    console.log("create list for date "+ sDate);
                    _self.couriersMap.set(sDate, []);
                }
                _self.couriersMap.get(sDate).push( {
                    name: sCourierName,
                    firstName: s.courier.firstName,
                    choosedTime: getDriverStartTime(s.startShift)
                })
            })
            _self.isLoading = false
            _self.generateCSV(dates, true, margin)
        })
        .catch((error) => {
            console.log(error);
            _self.hasError = error.message
        })
}

function capitalizeName(name){
    let names = name.split(" ");
    if(names.length === 1) return name;
    if(names.length > 1){
        var finalName = '' + names[0].charAt(0) +'.';
        for(var i = 1; i < names.length; i++){
            finalName += ' '+ names[i];
        }
        return finalName;
    }
    return name;
}

function getDriverStartTime(startShift){
    var returnValue;
    try{
        var time = startShift.split(":");
        returnValue = {HH: time[0] , mm: time[1]};
    }catch (e){
        returnValue = {HH: '08' , mm: '00'};
    }
    return returnValue;
}

function generateCSV(dates, generatePdf, margin){
    let _self = this;
    var maxCourierSize = 0;
    var csvFile = "";
    // var csvFile = "data:text/csv;charset=utf-8,\n";
    for(var i = 0; i < dates.length; i++){
        let potpis = i === dates.length - 1 ? ", Potpis" : ", Potpis ,";
        csvFile = csvFile + dates[i] + potpis
    }
    csvFile = csvFile + "\n";
    for(var ii = 0; ii < dates.length; ii++){
        var currentList = _self.couriersMap.get(dates[ii]);
        if(currentList.length > maxCourierSize){
            maxCourierSize = currentList.length
        }
    }

    for (var j = 0; j < maxCourierSize - 1; j++){
        for(var d = 0; d < dates.length; d++){
            var list = this.couriersMap.get(dates[d]).sort((a,b) => _self.compareDriversByTime(a,b));
            let cName = j >= list.length ? '' : '' + list[j].name;
            let lastSpace = d === dates.length - 1 ? ",  " : ",  ,"
            csvFile = csvFile + cName + lastSpace
        }
        csvFile = csvFile + "\n";
    }
    console.log(csvFile)
    if(generatePdf){
        _self.generatePDF(csvFile, margin);
        return;
    }
    var universalBOM = "\uFEFF";
    // var encodedUri = encodeURI(csvFile);
    var link = document.createElement("a");
    link.setAttribute("href", 'data:text/csv; charset=utf-8,' + encodeURIComponent(universalBOM+csvFile));
    link.setAttribute("download", "izvestaj.csv");
    document.body.appendChild(link); // Required for FF
    link.click(); // This will download the data file nam
}

function generatePDF(csvFile, margin){
    let _self = this;
    // var from = this.$moment(Date.parse(this.fromDate)).format('DD.MM.YYYY.')
    // var to = this.$moment(Date.parse(this.toDate)).format('DD.MM.YYYY.')
    var temp = csvFile.split("\n");
    var mainBody = [];
    var widthRow = [];
    for(var i = 0; i < temp.length - 1; i++){
        var row = temp[i].split(",")
        var tempRow = [];
        if(widthRow.length === 0){
            for(var k = 0; k < row.length; k++){
                if(k % 2 === 0){
                    // widthRow.push(55)
                    widthRow.push('auto')
                }else {
                    widthRow.push('*')
                }
            }
        }
        for(var j = 0; j < row.length; j++){
            tempRow.push({text: '' + row[j], style: 'mainRowTable'})

        }
        mainBody.push(tempRow);
    }

    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    var dd = {
        pageOrientation: 'landscape',
        content: [
            {
                style: 'tableExample',
                table: {
                    headerRows: 1,
                    widths: widthRow,//['auto', 'auto', 'auto', 'auto', 'auto','auto'],
                    body: mainBody
                },
                layout: {
                    fillColor: function (rowIndex, node, columnIndex) {
                        if(rowIndex === 0) return '#AAAAAA';
                        return (columnIndex % 2 === 0) ? '#CCCCCC' : null;
                    }
                }
                // layout: 'lightHorizontalLines'
            },
        ],
        styles: {
            header: {
                fontSize: 18,
                bold: true,
                margin: [0, 0, 0, 10]
            },
            headerRacun: {
                fontSize: 36,
                bold: true,
                margin: [0, 0, 0, 10]
            },
            subheader: {
                fontSize: 16,
                bold: true,
                margin: [0, 10, 0, 5]
            },
            companyInfo: {
                fontSize: 9,
                margin: [0, 10, 0, 5]
            },
            mainHeaderTable: {
                fontSize: 10,
                bold: true,
                margin: [0, 0, 0, 0]
            },
            mainRowTable: {
                fontSize: 8,
                // margin: [left, top, right , bottom],
                margin: [0, margin, 0 , margin],
                alignment: 'center'
            },
            miniHeaderTable: {
                fontSize: 8,
                bold: true,
                margin: [0, 0, 0, 0]
            },
            miniRowTable: {
                fontSize: 8,
                margin: [0, 0, 0, 0],
            },

            miniHeaderTable2: {
                fontSize: 12,
                bold: true,
                margin: [0, 0, 0, 0]
            },
            miniRowTable2: {
                fontSize: 12,
                margin: [0, 0, 0, 0]
            },

            tableExample: {
                margin: [0, 0, 0, 0]
            },
            miniTableExample: {
                margin: [0, 0, 0, 0]
            },
            tableHeader: {
                bold: true,
                fontSize: 13,
                color: 'black'
            }
        },

    }
    var fromD = this.$moment(Date.parse(_self.fromDate)).format('DD.MM.YYYY.')
    var toD = this.$moment(Date.parse(_self.toDate)).format('DD.MM.YYYY.')

    var fileName = 'Raspored od ' + fromD + ' do ' + toD + '.pdf';
    pdfMake.createPdf(dd).download(fileName)
}


function formatDate(date) {
    return this.$moment(new Date(date )).format('DD-MM-YYYY')
}

function changedDateFrom() {

}


function changedDateTo() {

}


// WEBPACK FOOTER //
// ./src/modals/PrintSchedule.js